/** Copied from https://github.com/MercuryTechnologies/mercury-web/blob/edb43de36e3cf3b0e3689a4eae09e0f5c6c630f8/src/design-system/DSAvatar/index.tsx
 * NB: Omitting the `ImageAvatar` variant because we don't use it
 *
 * In `mercury-web` are styles to change the avatar color based on the user's name/ initials. Got rid of
 * these because they were:
 * 1. using `color-mod()` function which is deprecated & we don't use in mercury-fem, so it would have
 * been a pain to convert
 * 2. mercury-fem uses a different color palette / the initials avatar colors are manually set, not
 * dynamic
 */

// TODO: This component is not up-to-date with Figma, see https://linear.app/mercury/issue/FE-181/update-avatar-component
/**
 * Design System - Avatar Component
 * https://mercury.design/system?p=avatar
 * https://www.figma.com/file/S7Q78jkg0O92CodjYielQO/%F0%9F%92%BB-Design-System---Web?node-id=133%3A4762
 */

import React from 'react'
import TextAvatar, {type AvatarTextProps} from './_subcomponents/TextAvatar'

export type MWDSAvatarProps = AvatarTextProps

/**
 * An Avatar is a visual representation of a person or business. It contains initials.
 */
const MWDSAvatar = ({name, ...divProps}: MWDSAvatarProps) => {
  /** Avatar is now responsible solely for determining which type of Avatar is to be
   * rendered based on the props passed in, and then delegates the rest to the corresponding
   * child component */
  return <TextAvatar name={name} {...divProps} />
}

export default MWDSAvatar
